module.exports = __webpack_public_path__ + "static/img/lianxiwomen.4c886a86.png";